import { type IApiResponse } from '@/helpers/types';

import { coreApiSlice } from '../apiSlice';

const zoneApislice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getZones: builder.query<IApiResponse, {}>({
			query: (params) => ({ url: '/Zone', params }),
		}),
		createZone: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/Zone',
				body,
			}),
		}),
		getZoneById: builder.query({
			query: (params) => ({
				url: '/Zone',
				params,
			}),
		}),
		getZoneByName: builder.query({
			query: (params) => ({
				url: '/Zone/name',
				params,
			}),
		}),
		updateZone: builder.mutation({
			query: (body) => ({
				method: 'PUT',
				url: '/Zone/update',
				body,
			}),
		}),
		deleteZoneById: builder.mutation({
			query: (id) => ({
				method: 'DELETE',
				url: `/Zone/delete/${id}`,
			}),
		}),
	}),
});

export const {
	useGetZonesQuery,
	useLazyGetZonesQuery,
	useCreateZoneMutation,
	useGetZoneByIdQuery,
	useGetZoneByNameQuery,
	useUpdateZoneMutation,
	useDeleteZoneByIdMutation,
} = zoneApislice;
